import { render, staticRenderFns } from "./r-product-group-dialog.vue?vue&type=template&id=903ac390&scoped=true"
import script from "./r-product-group-dialog.vue?vue&type=script&lang=js"
export * from "./r-product-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-product-group-dialog.vue?vue&type=style&index=0&id=903ac390&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903ac390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('903ac390')) {
      api.createRecord('903ac390', component.options)
    } else {
      api.reload('903ac390', component.options)
    }
    module.hot.accept("./r-product-group-dialog.vue?vue&type=template&id=903ac390&scoped=true", function () {
      api.rerender('903ac390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product-group/r-product-group-dialog.vue"
export default component.exports